export const MOCKED_MODES = {
  mocked: 'mocked',
  mockedAdmin: 'mockedAdmin',
  mockedNonAdmin: 'mockedNonAdmin'
} as const;

export type MockedMode = (typeof MOCKED_MODES)[keyof typeof MOCKED_MODES];

// Read from the environment on every call (not at import time) so tests can switch the mode per test.
export const getMockedMode = (): MockedMode | undefined =>
  Object.values(MOCKED_MODES).find((mode) => mode === process.env.REACT_APP_MODE);

export const isMockedMode = () => getMockedMode() !== undefined;
